import { useRef, useEffect } from "react";
import { useDispatch } from "react-redux";
import axios from "axios";

import {
  setAudienceLoading,
  setAudienceData,
  clearAudienceData,
  setIsAudienceDataError,
  clearAllSelectedUsers,
} from "src/app/pages/CreatorDiscoveryTool/legacy/app/audiences-manager/CreatorSearch/redux/creatorSearchActions";
import responseCodes from "src/utils/responseCodes";
import { openTrialExceededModal } from "src/redux";
import { setSubscriptionEntitlementErrors } from "src/redux/main/mainActions";
import { getQueryDataObject } from "../utils";
import CONSTS from "src/app/pages/CreatorDiscoveryTool/legacy/app/helpers/consts";
import METHODS from "src/app/pages/CreatorDiscoveryTool/legacy/app/helpers/methods";

export default function useSearchCreators(
  baseFilters,
  sortBy,
  sortOrder,
  projectId,
) {
  const creatorSearchRequest = useRef(null);
  const prevBaseFilters = useRef(null);

  const dispatch = useDispatch();

  const abortSearchAudienceRequest = () => {
    creatorSearchRequest?.current?.cancel();
  };

  useEffect(() => {
    const searchCreators = async () => {
      const queryData = getQueryDataObject(baseFilters, 1, sortBy, sortOrder);

      const queryDataString = JSON.stringify(queryData);
      const haveBaseFiltersChanged =
        queryDataString !== prevBaseFilters.current;

      if (!haveBaseFiltersChanged) return;

      abortSearchAudienceRequest();
      creatorSearchRequest.current = axios.CancelToken.source();

      dispatch(setAudienceLoading(true));
      dispatch(setIsAudienceDataError(false));
      dispatch(clearAllSelectedUsers());

      const url = CONSTS.creatorSearchByFilters;
      prevBaseFilters.current = queryDataString;

      axios
        .post(url, queryData, {
          headers: {
            "Workspace-Uuid": METHODS.getWorkspaceUuidFromCurrentUrl(),
            ...(projectId ? { "Project-Uuid": projectId } : {}),
          },
          cancelToken: creatorSearchRequest.current.token,
        })
        .then((res) => {
          if (res.data.status_code === responseCodes["200_OK"]) {
            dispatch(setAudienceData(res.data.content));
            dispatch(setAudienceLoading(false));
          }
        })
        .catch((error) => {
          console.error(error);
          if (axios.isCancel(error)) return;

          dispatch(setAudienceLoading(false));
          if (axios.isAxiosError(error)) {
            const { response } = error;
            if (response.status === responseCodes["402_PAYMENT_REQUIRED"]) {
              dispatch(openTrialExceededModal());
              dispatch(setSubscriptionEntitlementErrors(response.data.errors));
              return;
            }
          }
          dispatch(clearAudienceData());
          dispatch(setIsAudienceDataError(true));
        });
    };
    searchCreators();
  }, [dispatch, baseFilters, sortBy, sortOrder, projectId]);

  useEffect(() => {
    return () => {
      abortSearchAudienceRequest();
    };
  }, []);
}
